// Kept free of zod so browser code (landing deep links) can read the limit
// without pulling the schema library into first-paint JS.
export const MAX_TRACKED_JOB_ID_LENGTH = 512;
